module.exports = __webpack_public_path__ + "static/wax_banner-b8620ad3b015d6af4408249b5b0dface.jpg";